<app-spinner-service></app-spinner-service>

<div class="detail-page-wrapper p-4" *ngIf="extrato">
  <div class="detail-card">
    <div class="detail-header">
      <div class="header-icon"><i class="pi pi-building"></i></div>
      <div class="header-info">
        <h2 class="detail-title">{{ extrato.nomeBanco }}</h2>
        <p class="detail-subtitle">Extrato · {{ extrato.mesAno || extrato.mes + '/' + extrato.ano }}</p>
      </div>
    </div>

    <div class="info-section">
      <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações do Extrato</span></div>
      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-credit-card"></i><span>Número da Conta</span></div>
          <div class="detail-value">{{ extrato.numeroConta }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar"></i><span>Período</span></div>
          <div class="detail-value">{{ extrato.mesAno || extrato.mes + '/' + extrato.ano }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-map-marker"></i><span>Agência</span></div>
          <div class="detail-value">{{ extrato.agencia }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar-times"></i><span>Data Inicial</span></div>
          <div class="detail-value">{{ extrato.dataInicial | date: 'dd/MM/yyyy' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar-check"></i><span>Data Final</span></div>
          <div class="detail-value">{{ extrato.dataFinal | date: 'dd/MM/yyyy' }}</div>
        </div>
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-file-excel"></i><span>Tipo de Arquivo</span></div>
          <div class="detail-value">
            <span [ngClass]="{'file-type-badge': true, 'planilha': extrato.ehPlanilha, 'ofx': !extrato.ehPlanilha}">
              {{ extrato.ehPlanilha ? 'Planilha Excel' : 'Arquivo OFX' }}
            </span>
          </div>
        </div>
        <div class="detail-item full-width">
          <div class="detail-label"><i class="pi pi-list"></i><span>Total de Transações</span></div>
          <div class="detail-value">{{ linhasExtrato.length }} transações registradas</div>
        </div>
      </div>
    </div>

    <div class="info-section">
      <div class="section-title"><i class="pi pi-table"></i><span>Linhas do Extrato</span></div>
      <p class="section-subtitle">Visualize todas as transações registradas neste extrato</p>

      <p-table
        [value]="linhasExtrato"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20, 50]"
        styleClass="detail-table"
        [loading]="loading"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros">

        <ng-template pTemplate="header">
          <tr>
            <th>Data</th>
            <th>Descrição</th>
            <th>Valor</th>
            <th>Moeda</th>
            <th>Tipo Transação</th>
            <th>Conta Contrapartida</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-linha>
          <tr>
            <td>{{ formatarDataOperacao(linha.dataOperacao) | date: 'dd/MM/yyyy' }}</td>
            <td [pTooltip]="linha.descricao" tooltipPosition="top">{{ linha.descricao }}</td>
            <td>{{ formataValorPositivoHelper.formatarSaldoPositivo(linha.valor) | currency }}</td>
            <td>{{ linha.moeda }}</td>
            <td>
              <span class="chip" [ngClass]="{ 'chip-credito': linha.tipoTransacao === 1, 'chip-debito': linha.tipoTransacao === 2 }">
                {{ getTipoTransacaoLabel(linha.tipoTransacao) }}
              </span>
            </td>
            <td [pTooltip]="linha.descricaoContaContabil" tooltipPosition="top">{{ linha.descricaoContaContabil }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="6" class="empty-message">
              <i class="pi pi-spin pi-spinner"></i>
              <p>Carregando linhas do extrato...</p>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="empty-message">Nenhuma linha encontrada neste extrato.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="mt-3">
    <button pButton type="button" label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="voltar()"></button>
  </div>
</div>
